import { render } from "./WithdrawalWhitelistPopup.vue?vue&type=template&id=48f64294&ts=true"
import script from "./WithdrawalWhitelistPopup.vue?vue&type=script&lang=ts"
export * from "./WithdrawalWhitelistPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__